import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import { useAuthStore } from "@/store/authStore";
import { demoStudentDashboard } from "@/data/demoData";
import { unwrapApiObject } from "@/lib/api-response";

export function useStudentDashboard() {
  const { user } = useAuthStore();

  return useQuery({
    queryKey: ["student-dashboard"],
    queryFn: async () => {
      if (user?.isDemo) {
        return demoStudentDashboard;
      }
      try {
        const res = await apiClient.get("/students/me/dashboard");
        return unwrapApiObject(res);
      } catch (error) {
        console.error("Failed to fetch student dashboard:", error);
        throw error;
      }
    },
  });
}

export function useSubmitWorkLog() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: {
      date: string;
      hours: number;
      description: string;
      challenge?: string;
    }) => {
      const res = await apiClient.post("/students/me/work-logs", data);
      return res.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["student-dashboard"] });
      queryClient.invalidateQueries({ queryKey: ["student-work-logs-list"] });
    },
  });
}
